<template>
    <or-layout>
        <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col :span="5">
            </a-col>
            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-select v-model="searchFrom.subject" placeholder="学科" style="width: 120px;">
                            <a-select-option :value="1">数学</a-select-option>
                            <a-select-option :value="2">英语</a-select-option>
                            <a-select-option :value="3">语文</a-select-option>
                            <a-select-option :value="4">化学</a-select-option>
                            <a-select-option :value="5">物理</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.type" placeholder="班型" style="width: 120px;" allow-clear>
                            <a-select-option :key="0" :value="0">培优班</a-select-option>
                            <a-select-option :key="1" :value="1">提高班</a-select-option>
                            <a-select-option :key="2" :value="2">英才班</a-select-option>
                            <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                            <a-select-option :key="4" :value="4">体验课</a-select-option>
							 <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                            <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.course_id" placeholder="课程" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 120px;">
                            <a-select-option :key="0" value="2020">2020年</a-select-option>
                            <a-select-option :key="1" value="2021">2021年</a-select-option>
                            <a-select-option :key="2" value="2022">2022年</a-select-option>
                            <a-select-option :key="3" value="2023">2023年</a-select-option>
							 <a-select-option :key="4" value="2024">2024年</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in nianjiList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 120px;">
                            <a-select-option :key="0" value="寒假">寒假</a-select-option>
                            <a-select-option :key="1" value="春季">春季</a-select-option>
                            <a-select-option :key="2" value="暑假">暑假</a-select-option>
                            <a-select-option :key="3" value="秋季">秋季</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.is_famission" placeholder="是否发送任务" allow-clear style="width: 80px;">
                            <a-select-option :key="0" :value="0">不发送</a-select-option>
                            <a-select-option :key="1" :value="1">发送</a-select-option>

                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">未开班</a-select-option>
                            <a-select-option :key="1" :value="1">已开班</a-select-option>
                            <a-select-option :key="2" :value="2">已结班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.status" placeholder="班级状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">禁用</a-select-option>
                            <a-select-option :key="1" :value="1">可用</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="班级名称" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.isjsgz" placeholder="是否计算" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="1">计算</a-select-option>
                            <a-select-option :key="1" :value="0">不计算</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <h3> 总计：{{ counts }}</h3>
            <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                @change="onPaginationChange" bordered>
                <a-table-column key="gradename" title="年级" data-index="gradename" />
                <a-table-column key="name" title="班级" data-index="name" />
                <a-table-column key="campusname" title="校区" data-index="campusname" />
                <a-table-column key="actual" title="实际人数" data-index="actual" />
                <a-table-column key="code" title="班级码" data-index="code" />
                <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                <a-table-column key="teacher" title="任课老师" data-index="teacher" />
                <a-table-column key="status" width="100px;" title="是否计算">
                    <template slot-scope="item">
                        <a-switch v-model="item.isjsgz" checked-children="是" un-checked-children="否"
                            @change="fun => setisjsgz(item.id, item.isjsgz)" />
                    </template>
                </a-table-column>
            </a-table>
        </div>
        <a-modal :visible="visible" title="班级信息编辑" @ok="modalSave" :destroyOnClose="true" @cancel="modalCancel">
            <a-form>
                <a-row :gutter="[16, 16]" type="flex" justify="space-between">
                    <a-col :span="12">
                        <a-input type="hidden" v-model="form.id" />
                        <a-form-item>
                            <a-input v-model="form.name" placeholder="班级名字" />
                        </a-form-item>
                        <a-form-item>
                            <a-input v-model="form.bjxh" placeholder="班级序号" />
                        </a-form-item>
                        <a-form-item>
                            <a-input v-model="form.jcname" placeholder="简称" />
                        </a-form-item>
                        <a-form-item>
                            <a-input type="number" v-model="form.amount" placeholder="班级人数" />
                        </a-form-item>

                        <a-form-item>
                            <a-select v-model="form.interval" placeholder="间隔时间" allow-clear>
                                <a-select-option :key="4" :value="4">每周五</a-select-option>
                                <a-select-option :key="0" :value="1">每周六</a-select-option>
                                <a-select-option :key="1" :value="2">每周天</a-select-option>
                                <a-select-option :key="2" :value="3">每天</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.phase" placeholder="阶段" allow-clear>
                                <a-select-option :key="0" :value="1">第一阶段(上午8:00-10:00)</a-select-option>
                                <a-select-option :key="1" :value="2">第二阶段(上午10:00-12:00)</a-select-option>
                                <a-select-option :key="2" :value="3">第三阶段(下午14:30-16:30)</a-select-option>
                                <a-select-option :key="3" :value="4">第四阶段(下午16:30-18:30)</a-select-option>
                                <a-select-option :key="4" :value="5">第五阶段(下午18:30-20:30)</a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item>
                            <a-input type="text" v-model="form.live_path" placeholder="直播地址" />
                        </a-form-item>

                        <a-form-item>
                            <a-select @change="changeFormCampus" v-model="form.campus_id" placeholder="校区" allow-clear>
                                <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">{{ item.name
                                }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.grade_id" placeholder="年级" allow-clear>
                                <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.type" placeholder="班型" allow-clear>
                                <a-select-option :key="0" :value="0">培优班</a-select-option>
                                <a-select-option :key="1" :value="1">提高班</a-select-option>
                                <a-select-option :key="2" :value="2">英才班</a-select-option>
                                <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                                <a-select-option :key="4" :value="4">体验课</a-select-option>
								  <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item>
                            <a-select v-model="form.semester_name" placeholder="季度" allow-clear>
                                <a-select-option :key="0" value="寒假">寒假</a-select-option>
                                <a-select-option :key="1" value="春季">春季</a-select-option>
                                <a-select-option :key="2" value="暑假">暑假</a-select-option>
                                <a-select-option :key="3" value="秋季">秋季</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.subject" placeholder="学科" allow-clear>
                                <a-select-option :key="1" :value="1">数学</a-select-option>
                                <a-select-option :key="2" :value="2">英语</a-select-option>
                                <a-select-option :key="3" :value="3">语文</a-select-option>
                                <a-select-option :key="4" :value="4">化学</a-select-option>
                                <a-select-option :key="5" :value="5">物理</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.year_name" placeholder="年度" allow-clear>
                                <a-select-option :key="0" value="2021">2021年</a-select-option>
                                <a-select-option :key="1" value="2022">2022年</a-select-option>
                                <a-select-option :key="2" value="2023">2023年</a-select-option>
								 <a-select-option :key="3" value="2024">2024年</a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item>
                            <a-select optionFilterProp="children" show-search v-model="form.instructor" placeholder="班主任"
                                allow-clear>
                                <a-select-option v-for="(item) in courseTeacherList" :key="item.id" :value="item.id">{{
                                    item.nickname }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select optionFilterProp="children" show-search v-model="form.admin_id" placeholder="任课老师"
                                allow-clear>
                                <a-select-option v-for="(item) in courseTeacherList" :key="item.id" :value="item.id">{{
                                    item.nickname }}-{{ item.mobile }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.course_id" placeholder="课程" allow-clear>
                                <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{ item.name
                                }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.is_famission" placeholder="是否发送任务" allow-clear>
                                <a-select-option :key="0" :value="0">不发送</a-select-option>
                                <a-select-option :key="1" :value="1">发送</a-select-option>

                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="form.opening" placeholder="开班状态" allow-clear>
                                <a-select-option :key="0" :value="0">未开班</a-select-option>
                                <a-select-option :key="1" :value="1">已开班</a-select-option>
                                <a-select-option :key="2" :value="2">已结班</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>

    </or-layout>
</template>
  
<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
//   import Squadinfo from '@/views/basic/orgquadinfomodel.vue';
export default {
    components: { AFormItem },
    data() {
        return {
            data: [],
            counts: undefined,
            courseChapterVisible: false,
            pageinfo: { total: 1, current: 1, pageSize: 10 },
            loading: false,
            visible: false,
            bindVisible: false,
            nianjiList: [],
            courseList: [],
            courseTeacherList: [],
            searchFrom: {
                keyword: undefined,
                course_id: undefined,
                campus_id: undefined,
                subject: undefined,
                opening: 1,
                status: 1,
                isjsgz: 1
            },
            courseChapterList: [],
            campusList: [],
            form: {
                id: undefined,
                name: undefined,
                course_id: undefined,
                grade_id: undefined,
                admin_id: undefined,
                instructor: undefined,
                amount: undefined,
                type: undefined,
                interval: undefined,
                phase: undefined,
                jcname: undefined,
                bjxh: undefined
            },
            gradeList: []
        };
    },
    mounted() {
        this.getCampusList();
        this.getGradeList();
        this.getNianjiList();
    },
    methods: {
        changeFormCampus(campus_id) {
            this.getCourseTeacherList({ campus_id: campus_id });
        },
        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.gradeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCourseTeacherList() {
            this.$axios
                .post("/api/OrgCampus/getteacher", { pageinfo: { pageSize: 9999 } })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseTeacherList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        getNianjiList() {
            this.$axios
                .post("/api/BasicGrade/index", {
                    pageinfo: {
                        pageSize: 999
                    }
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.nianjiList = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        getCourseList() {
            this.$axios
                .post("/api/BasicCourse/index", { data: { status: 1 },pageinfo: { pageSize: 9999 } })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/Admin/getorgsquadlist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data.org_campus;
                        this.tableSearch();
                        this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        selectItem(pid) {
            this.form.pid = pid;
        },

        changeStatus(data) {
            this.$axios
                .post("/api/OrgSquad/edit", { data })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.tableSearch();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        changeCampus(e) {
            this.searchForm.campus_id = e;
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList(this.searchFrom);
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.getTableList(this.searchFrom);
        },
        getTableList(data) {
            this.loading = true;
            this.$axios
                .post("/api/OrgSquad/index", {
                    data,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.data = res.data.data;
                        this.counts = res.data.counts;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },
        tableEdit(item) {
            item = JSON.parse(JSON.stringify(item));
            this.getCourseTeacherList({ campus_id: item.campus_id });
            this.form = item;
            this.visible = true;
        },
        setisjsgz(id, isjsgz) {
            this.loading = true;
            this.$axios
                .post("/api/OrgSquad/setifjsgz", {
                    data: {
                        isjsgz,
                        id
                    }
                })
                .then((res) => {
                    this.loading = false;
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    }
                    else {
                        this.$success({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });

                    }

                })
                .catch((err) => {
                    console.error(err);
                });
        },

        tableAdd() {
            this.form = {};
            this.form.campus_id = this.searchFrom.campus_id;
            this.getCourseTeacherList({ campus_id: this.form.campus_id });
            this.visible = true;
        },
        tableDel(data) {
            let _this = this;
            this.$confirm({
                title: "删除班级",
                content: "确认删除当前班级吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/OrgSquad/del", { data })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.tableSearch();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
        },
        modalSave() {
            let _this = this;
            if (!this.form.course_id) {
                _this.$error({
                    title: "错误",
                    content: "必须选择所属课程",
                    okText: "确定"
                });
                return false;
            }
            let url = "/api/OrgSquad/edit";
            if (!this.form.id) {
                url = "/api/OrgSquad/add";
            }
            this.$axios
                .post(url, { data: this.form })
                .then(res => {
                    if (res.code != 200) {
                        _this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        _this.tableSearch();
                        _this.visible = false;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        modalCancel() {
            this.visible = false;
            this.bindVisible = false;
        },
        modalCourseChapterCancel() {
            this.courseChapterVisible = false;
        }
    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>